module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "month"
  }, [_c('div', {
    staticClass: "full-calendar-header"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "full-calendar-body"
  }, [_c('div', {
    staticClass: "weeks"
  }, _vm._l((_vm.weekNames), function(week) {
    return _c('div', {
      staticClass: "week"
    }, [_vm._v(_vm._s(week))])
  }), 0), _c('div', {
    ref: "dates",
    staticClass: "dates"
  }, [_c('div', {
    staticClass: "dates-bg"
  }, _vm._l((_vm.currentDates), function(week) {
    return _c('div', {
      staticClass: "week-row"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "day-cell",
        class: {
          "today": day.isToday,
          "not-cur-month": !day.isCurMonth,
          "weekend": day.weekDay > 4,
          "isFutureDate": day.isFutureDate
        },
        attrs: {
          "track-by": "$index"
        }
      }, [_vm._l((day.events), function(event) {
        return _c('div', {
          staticClass: "event-item",
          class: {
            "is-start": _vm.isStart(event.start, day.date),
            "is-end": _vm.isEnd(event.end, day.date),
            "holiday": _vm.isHoliday(event),
            "public": _vm.isPublic(event)
          }
        })
      }), _vm._l((day.newVacations), function(event) {
        return _c('div', {
          staticClass: "event-item new-vacations",
          class: {
            "is-start": _vm.isStart(event.start, day.date),
            "is-end": _vm.isEnd(event.end, day.date),
            "newHoliday": _vm.isNewHoliday(event),
            "newHolidayPublic": _vm.isNewHolidayPublic(event)
          }
        })
      }), _c('div', {
        staticClass: "day-number",
        class: {
          "clickable": day.isFutureDate || day.events.length > 0 || !_vm.isHolidaysCalendar
        },
        on: {
          "click": function($event) {
            return _vm.selectThisDay(day, $event)
          }
        }
      }, [_vm._v(_vm._s(day.monthDay))])], 2)
    }), 0)
  }), 0), _c('BookHolidayPopup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpened()),
      expression: "isOpened()"
    }],
    style: ({
      left: _vm.morePos.left + "px",
      top: _vm.morePos.top + "px"
    }),
    attrs: {
      "startDate": _vm.getStartDate,
      "endDate": _vm.getEndDate,
      "bookedDays": _vm.getBookedDays,
      "isHolidaysCalendar": _vm.isHolidaysCalendar,
      "editing": _vm.getEditingId,
      "boxTop": _vm.boxTop,
      "boxLeft": _vm.boxLeft,
      "workingDays": _vm.workingDays,
      "holidayName": _vm.holidayName,
      "showOnly": _vm.showOnly
    },
    on: {
      "show": function($event) {
        return _vm.changeShow()
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5affc9fd"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/Month/Month.pug
// module id = 184
// module chunks = 1